import type { ReactElement } from 'react';

import { ErrorBoundarySuspense } from 'src/components/suspenses/ErrorBoundarySuspense';
import { ConfigurationReferences } from 'src/features/configuration/configurationReferences/ConfigurationReferences';
import { ConfigurationReferencesSkeleton } from 'src/features/configuration/configurationReferences/ConfigurationReferencesSkeleton';
import { useForecastSession } from 'src/features/forecastSessions/useForecastSession';
import { QUERY_KEY_OPEN_SESSION_PRODUCTS } from 'src/keys';

export function ConfigurationReferencesContainer(): ReactElement {
  const { activeSession } = useForecastSession();

  if (!activeSession?.id) {
    return <ConfigurationReferencesSkeleton />;
  }

  return (
    <ErrorBoundarySuspense
      errorFallbackWrapper={
        <div className={'flex h-44 w-full flex-col gap-y-4 p-4'} />
      }
      loadingFallback={<ConfigurationReferencesSkeleton />}
      queryKey={[QUERY_KEY_OPEN_SESSION_PRODUCTS, activeSession?.id]}
    >
      <ConfigurationReferences sessionId={activeSession.id} />
    </ErrorBoundarySuspense>
  );
}
